import Slider from './slider'

const Cover = () => {
  return (
    <div className='lg:col-span-4 lg:row-end-1'>
      <Slider />
    </div>
  )
}

export default Cover
